import { Routes } from '@angular/router';

import { microsoftLicensesSegments } from '@advania-cosoftware/wolf-router';

export const microsoftLicensesRoutes: Routes = [
    {
        path: microsoftLicensesSegments.microsoftLicenses,
        loadComponent: () =>
            import('./pages/microsoft-licenses-page/microsoft-licenses.page').then((m) => m.MicrosoftLicensesPage),
    },
    {
        path: `${microsoftLicensesSegments.microsoftLicenses}/:tenantName/:offer`,
        loadComponent: () =>
            import('./pages/microsoft-license-page/microsoft-license.page').then((m) => m.MicrosoftLicensePage),
    },
];
